/* tslint:disable */
/* eslint-disable */
/**
 * Airline API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const RequestType = {
    PostBooking: 'post_booking',
    Reprice: 'reprice',
    Ancillary: 'ancillary',
    Bundle: 'bundle',
    Fare: 'fare'
};
export function RequestTypeFromJSON(json) {
    return RequestTypeFromJSONTyped(json, false);
}
export function RequestTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function RequestTypeToJSON(value) {
    return value;
}
